export const tagMapping = {
    Producer: '#ecd5d5',
    Director: '#d8d8e9',
    Editor: '#d6e7ea',
    Videographer: '#fff7d6'
}
